import { useEffect, useState } from "react";

// Base URL every image in the app is built from. It arrives with the site
// config that public/index.html fetches on boot, so on a cold load it is not
// there yet - components that read it once at mount end up with an empty src
// and paint a broken image.
const readImageBase = () =>
  (window.site && window.site.common && window.site.common.imageCloudfront) ||
  process.env.REACT_APP_IMAGE_CLOUD_FRONT ||
  "";

const POLL_INTERVAL = 200;
const POLL_TIMEOUT = 10000;

/**
 * Returns the CloudFront image base URL, re-rendering the caller once the site
 * config lands. Empty string until then - callers must render a fallback
 * rather than an <img> with a half-built src.
 */
export default function useCloudfrontImage() {
  const [image, setImage] = useState(readImageBase);

  useEffect(() => {
    if (image) return undefined;

    const poll = setInterval(() => {
      const next = readImageBase();
      if (next) {
        clearInterval(poll);
        setImage(next);
      }
    }, POLL_INTERVAL);
    const stopPolling = setTimeout(() => clearInterval(poll), POLL_TIMEOUT);

    return () => {
      clearInterval(poll);
      clearTimeout(stopPolling);
    };
  }, [image]);

  return image;
}
